<template>
    <fragment>
        <touchpoint-overview-row>
            <template v-slot:left v-if="displaySource">
                <touchpoint-statistics-overview-cell
                    class="row"
                    :category="categoryTypes.source"
                    :selected-category="detailsSelectedCategoryLabel"

                    @select="selectDetailsCategory"
                >
                    <div class="col-2">
                        <i :class="sourceBrickIcon" />
                    </div>
                    <div class="col-10">
                        <span class="description">{{sourceBrickName}}</span>
                        <br />
                        <span class="amount">{{sourceAmount | formatNumber}}</span>
                    </div>
                </touchpoint-statistics-overview-cell>
            </template>

            <template v-slot:center v-if="displaySelected">
                <touchpoint-statistics-overview-cell
                    :category="categoryTypes.condition"
                    :selected-category="detailsSelectedCategoryLabel"

                    @select="selectDetailsCategory"
                >
                    <span class="description">{{selectedName}}</span>

<!--                    <template v-for="({description}, index) in conditions">-->
<!--                        <span class="description" :key="`${description}-${index}`" >-->
<!--                            {{description}}-->
<!--                            <br />-->
<!--                        </span>-->
<!--                    </template>-->

                    <span class="amount">{{selectedAmount | formatNumber}}</span>
                </touchpoint-statistics-overview-cell>
            </template>

            <template v-slot:right v-if="displayDestination">
                <touchpoint-statistics-overview-cell
                    class="row"
                    :category="categoryTypes.destination"
                    :selected-category="detailsSelectedCategoryLabel"
                    
                    @select="selectDetailsCategory"
                >
                    <div class="col-10">
                        <span class="description">{{destinationBrickName}}</span>
                        <br />
                        <span class="amount">{{destinationAmount | formatNumber}}</span>
                    </div>
                    <div class="col-2">
                        <i :class="destinationBrickIcon" />
                    </div>
                </touchpoint-statistics-overview-cell>
            </template>
        </touchpoint-overview-row>

        <template v-if="displayDetails">
            <touchpoint-statistics-details
                    :key="detailsSelectedCategoryLabel"
                    
                    v-if="!isLoadingDetails"

                    @filters-changed="detailsTypeFiltersChanged"
                    
                    :statistics-details="detailsSelectedCategory"
            >
            </touchpoint-statistics-details>
            <loading-box class="position-relative" v-else/>
        </template>
    </fragment>
</template>

<script>
    import moment from "moment";

    import api from '@modules/JourneyBuilder/api';
    import loader from "@core/Util/loader";
    import {getBrickIconClass as getBrickIcon} from "@modules/JourneyBuilder/Bricks/brick-icons";
    import {bootstrapDangerGrowl} from "@core/Util/growler";

    import formattedNumberFilterMixin from '@modules/JourneyBuilder/Mixins/formatted-number-filter'

    import TouchpointOverviewRow from "../TouchpointOverviewRow.vue";
    import TouchpointStatisticsOverviewCell from "./TouchpointStatisticsOverviewCell.vue";
    import TouchpointStatisticsDetails from "./TouchpointStatisticsDetails.vue";
    import LoadingBox from "@core/Components/Util/LoadingBox.vue";
    
    const categoryTypes = Object.freeze({
        source: 'source',
        condition: 'condition',
        destination: 'destination'
    });
    
    export default {
        name: 'touchpoint-statistics-overview-row',
        components: {
            LoadingBox,
            TouchpointOverviewRow,
            TouchpointStatisticsDetails,
            TouchpointStatisticsOverviewCell
        },
        mixins: [formattedNumberFilterMixin],
        created() {
            const vm = this;
            
            vm.detailsFilters = {
                startDate: moment()
                    .add(-14, 'days')
                    .format('YYYY-MM-DD'),

                typeFilters: []
            };
        },
        methods: {
            selectDetailsCategory(category){
                const vm = this;
                
                const previousCategory = vm.detailsSelectedCategoryLabel;
                vm.detailsSelectedCategoryLabel = category;
                
                //Ignore null/undefined, reset when attempting to set the same value twice
                if(category && category === previousCategory){
                    vm.closeDetails();
                    return;
                }

                //Loading should only happen on initial selection
                if(!previousCategory){
                    vm.loadDetails();
                }
            },
            closeDetails(){
                const vm = this;

                vm.detailsSelectedCategoryLabel = null;
                vm.detailsPerCategory = null;
                vm.detailsFilters.typeFilters = [];
            },
            detailsTypeFiltersChanged(selectedTypeFilters){
                this.detailsFilters.typeFilters = selectedTypeFilters;
            },
            loadDetails(){
                const vm = this;
                
                if(!vm.displayDetails){
                    return;
                }

                loader.showProgressCursor();
                
                api.getTouchpointTrafficStatistics(
                    vm.connectionId,
                    vm.detailsFilters
                ).then(
                    detailsPerCategory => {
                        vm.detailsPerCategory = detailsPerCategory;
                    },
                    (err) => {
                        vm.closeDetails();
                        bootstrapDangerGrowl(err);
                    }
                )
                .finally(() => loader.stopProgressCursor());
            }
        },
        watch: {
            detailsFilters: {
                deep: true,
                handler(){
                    this.loadDetails();
                }
            }
        },
        computed: {
            sourceBrickIcon(){
                return getBrickIcon(
                    this.sourceBrickType,
                    this.sourceBrickConfig
                );
            },
            destinationBrickIcon(){
                return getBrickIcon(
                    this.destinationBrickType,
                    this.destinationBrickConfig
                );
            },
            displayDetails(){
                //No label selected = no details selected
                return !!this.detailsSelectedCategoryLabel;
            },
            isLoadingDetails() {
                //Details selected but not loaded yet = loading details
                return !this.detailsPerCategory;
            },
            detailsSelectedCategory(){
                const vm = this;
                
                if(vm.detailsSelectedCategoryLabel && vm.detailsPerCategory){
                    return vm.detailsPerCategory[vm.detailsSelectedCategoryLabel];
                }
                
                return null;
            }
        },
        props: {
            connectionId: String,
            
            sourceBrickName: String,
            sourceBrickType: Number,
            sourceBrickConfig: Object,
            displaySource: Boolean,
            sourceAmount: Number,
            
            // conditions: Array,
            selectedName: String,
            displaySelected: Boolean,
            selectedAmount: Number,
            
            destinationBrickName: String,
            destinationBrickType: Number,
            destinationBrickConfig: Object,
            displayDestination: Boolean,
            destinationAmount: Number
        },
        data: () => ({
            detailsFilters: null,
            detailsSelectedCategoryLabel: null,
            detailsPerCategory: null,
            
            categoryTypes: categoryTypes
        })
    }
</script>

<style scoped lang="scss">
	@import "~@modules/JourneyBuilder/Style/touchpoint-statistics-row.scss";
</style>